// extracted by mini-css-extract-plugin
export default {"container":"VideoPlaceholder_container__UZzXw","icon":"VideoPlaceholder_icon__70GRr"};